import React from 'react';

import { headerIcons } from 'components/HeaderWithIcon/headerIcons';

import PageWithIcon from 'containers/PageWithIcon';

import GoBackHomeButton from '../Buttons/GoBackHome';
import ReloadButton from '../Buttons/Reload';

const GeneralError = () => (
  <PageWithIcon
    icon={headerIcons.errorShape}
    title={{ id: 'containers.App.generalErrorTitle' }}
    subtitle={{ id: 'containers.App.generalErrorMessage' }}
    buttons={[
      <ReloadButton key="ReloadButton" />,
      <GoBackHomeButton key="GoBackHomeButton" />,
    ]}
  />
);

export default GeneralError;
